module.exports = __webpack_public_path__ + "static/img/require.9ee6c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/require.png
// module id = x8Ik
// module chunks = 1